module.exports = ".timezone-section {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .timezone-section .timezone-label {\n    max-width: 125px; }\n  .timezone-section .timezone-dropdown {\n    max-width: 400px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/date-time-calendar/date-time-calendar.scss
// module id = ./web/modern/components/settings/date-time-calendar/date-time-calendar.scss
// module chunks = 0